import { useI18n } from 'vue-i18n';

export const GOAL_TYPES = [
  'sales_count',
  'revenue',
  'conversion_rate',
  'sales_time',
  'product_sales',
];

const numberFormat = new Intl.NumberFormat('pt-BR', {
  maximumFractionDigits: 2,
});
const currencyFormat = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

// Datas chegam como "YYYY-MM-DD"; não passam por Date para não deslocar o dia pelo fuso.
export const formatGoalDate = isoDate => isoDate.split('-').reverse().join('/');

export const useCommercialGoalFormat = () => {
  const { t } = useI18n();

  // Alvo/atual na unidade do tipo: nº, R$, % ou dias.
  const formatValue = (goalType, value) => {
    if (goalType === 'revenue') return currencyFormat.format(value);
    if (goalType === 'conversion_rate') return `${numberFormat.format(value)}%`;
    if (goalType === 'sales_time') {
      return t(
        'COMMERCIAL_GOALS.UNITS.DAYS',
        { n: numberFormat.format(value) },
        value
      );
    }
    return numberFormat.format(value);
  };

  // "Produto/Servico · Cabo HDMI": o tipo, mais o item quando a meta e de produto/servico.
  const formatType = goal => {
    const label = t(`COMMERCIAL_GOALS.TYPES.${goal.goalType.toUpperCase()}`);
    return goal.product ? `${label} · ${goal.product.name}` : label;
  };

  const formatPeriod = goal =>
    `${formatGoalDate(goal.startDate)} – ${formatGoalDate(goal.endDate)}`;

  return { formatValue, formatType, formatPeriod };
};
